import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-overlay-side-panel-content',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        flex: 1 1 auto;
        background: var(--bg);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlaySidePanelContentComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
